// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"header_HeaderWrapper_NpwaL","NavButton":"header_NavButton_W1n6L"};